import { useEffect } from 'react';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../contexts/AuthContext';
import { API } from '../config';

const MIN_GAP_MS = 5 * 60 * 1000;
let lastSent = 0;

const send = () => {
  const now = Date.now();
  if (now - lastSent < MIN_GAP_MS) return;
  lastSent = now;
  const platform = Capacitor.isNativePlatform() ? Capacitor.getPlatform() : 'web';
  // Fire-and-forget: never blocks app start.
  setTimeout(() => { axios.post(`${API}/activity/ping`, { platform }).catch(() => {}); }, 0);
};

// "App aperta / tornata in primo piano" → last_active + platform (admins excluded).
export default function ActivityPing() {
  const { user } = useAuth();
  const enabled = !!user && !user.is_admin;
  useEffect(() => {
    if (!enabled) return undefined;
    send();
    const onVisible = () => { if (document.visibilityState === 'visible') send(); };
    document.addEventListener('visibilitychange', onVisible);
    let resumeHandle;
    if (Capacitor.isNativePlatform()) {
      import('@capacitor/app').then(({ App }) => App.addListener('resume', send))
        .then((h) => { resumeHandle = h; }).catch(() => {});
    }
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      resumeHandle?.remove?.();
    };
  }, [enabled]);
  return null;
}
